import React, { useState } from "react";
import "./FBAR.css";
import CustomDropdown from "../../../../../Components/CustomDropdown/CustomDropdown";
import CustomTimeSelector from "../../../../Components/CustomTimeSelector/CustomTimeSelector";
import CustomTable from "../../../../Components/CustomTable/CustomTable";
import CustomSwitch from "../../../../../Components/CustomSwitch/CustomSwitch";
import { Checkbox, FormControlLabel, Radio, RadioGroup } from "@mui/material";

const FBAR = () => {
  return (
    <div className="cltdetails__fbar_page">
      <div className="cltdetails__fbar_contentwrap">
        <div className="cltdetails__fbar_contentbox">
          <div
            className="cltdetails__fbar_cboxheader"
            style={{ background: "rgba(5, 89, 91, 0.75)" }}
          >
            <div className="cltdetails__fbar_cboxhheading">
              Bank Information
            </div>
            <div className="cltdetails__fbar_cboxhdesc">
              A United States person, including a citizen, resident,
              corporation, partnership, limited liability company, trust and
              estate, must file FBAR
            </div>
            <div className="cltdetails__fbar_cboxhdesc">
              If the person transferred or maintained the aggregate value of
              those foreign financial accounts exceeded $10,000 at any time
              during the calendar year need to file
            </div>
          </div>
          <div className="cltdetails__fbar_cboxbody">
            <div className="cltdetails__fbar_cboxrow">
              <div className="cltdetails__fbar_cboxcol">
                <div className="cltdetails__fbar_cboxfieldbox">
                  <label className="cltdetails__fbar_cboxfieldlbl">
                    Ownership
                  </label>
                  <div className="cltdetails__fbar_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__fbar_cboxfield"
                      placeholder="Enter Name"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__fbar_cboxcol">
                <div className="cltdetails__fbar_cboxfieldbox">
                  <label className="cltdetails__fbar_cboxfieldlbl">
                    Name of Bank or Financial Institution
                  </label>
                  <div className="cltdetails__fbar_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__fbar_cboxfield"
                      placeholder="Name of the instituion"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__fbar_cboxcol">
                <div className="cltdetails__fbar_cboxfieldbox">
                  <label className="cltdetails__fbar_cboxfieldlbl">
                    Street Address:
                  </label>
                  <div className="cltdetails__fbar_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__fbar_cboxfield"
                      placeholder="Enter Address"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__fbar_cboxrow">
              <div className="cltdetails__fbar_cboxcol">
                <div className="cltdetails__fbar_cboxfieldbox">
                  <label className="cltdetails__fbar_cboxfieldlbl">City</label>
                  <div className="cltdetails__fbar_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__fbar_cboxfield"
                      placeholder="Enter City"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__fbar_cboxcol">
                <div className="cltdetails__fbar_cboxfieldbox">
                  <label className="cltdetails__fbar_cboxfieldlbl">State</label>
                  <div className="cltdetails__fbar_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__fbar_cboxfield"
                      placeholder="Enter State"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__fbar_cboxcol">
                <div className="cltdetails__fbar_cboxfieldbox">
                  <label className="cltdetails__fbar_cboxfieldlbl">
                    Postal Code
                  </label>
                  <div className="cltdetails__fbar_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__fbar_cboxfield"
                      placeholder="Enter Postal Code"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__fbar_cboxrow">
              <div className="cltdetails__fbar_cboxcol">
                <div className="cltdetails__fbar_cboxfieldbox">
                  <label className="cltdetails__fbar_cboxfieldlbl">
                    Account Number
                  </label>
                  <div className="cltdetails__fbar_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__fbar_cboxfield"
                      placeholder="Enter Account Number"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__fbar_cboxcol">
                <div className="cltdetails__fbar_cboxfieldbox">
                  <label className="cltdetails__fbar_cboxfieldlbl">
                    Type Of Account
                  </label>
                  <div className="cltdetails__fbar_cboxfieldwrap">
                    <CustomDropdown
                      customStyles={{
                        height: 56,
                        borderColor: "lightgrey",
                        marginTop: 0,
                      }}
                      options={["opt1"]}
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__fbar_cboxcol">
                <div className="cltdetails__fbar_cboxfieldbox">
                  <label className="cltdetails__fbar_cboxfieldlbl">
                    If others, please specify
                  </label>
                  <div className="cltdetails__fbar_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__fbar_cboxfield"
                      placeholder="Enter Description"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__fbar_cboxrow">
              <div className="cltdetails__fbar_cboxcol">
                <div className="cltdetails__fbar_cboxfieldbox">
                  <label className="cltdetails__fbar_cboxfieldlbl">
                    Foreign currency in which acct is maintained (INR, EUR, GBP,
                    etc.)
                  </label>
                  <div className="cltdetails__fbar_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__fbar_cboxfield"
                      placeholder="ex: INR"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__fbar_cboxcol">
                <div className="cltdetails__fbar_cboxfieldbox">
                  <label className="cltdetails__fbar_cboxfieldlbl">
                    Income earned in the account during 2020
                  </label>
                  <div className="cltdetails__fbar_cboxfieldwrap">
                    <CustomDropdown
                      customStyles={{
                        height: 56,
                        borderColor: "lightgrey",
                        marginTop: 0,
                      }}
                      options={["opt1"]}
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__fbar_cboxcol">
                <div className="cltdetails__fbar_cboxfieldbox">
                  <label className="cltdetails__fbar_cboxfieldlbl">
                    Total income earned in the account during 2020 (If line 7
                    'YES' please provide income details)
                  </label>
                  <div className="cltdetails__fbar_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__fbar_cboxfield"
                      placeholder="Enter Description"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__fbar_cboxrow">
              <div className="cltdetails__fbar_cboxcol">
                <div className="cltdetails__fbar_cboxfieldbox">
                  <label className="cltdetails__fbar_cboxfieldlbl">
                    Maximum Value of Account during 2020 in Foreign currency
                  </label>
                  <div className="cltdetails__fbar_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__fbar_cboxfield"
                      placeholder="Enter Value"
                    />
                  </div>
                </div>
              </div>

              <div className="cltdetails__fbar_cboxcol">
                <div className="cltdetails__fbar_cboxfieldbox">
                  <label className="cltdetails__fbar_cboxfieldlbl">
                    Value of Account as on 31-Dec-2020 in Foreign currency
                  </label>
                  <div className="cltdetails__fbar_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__fbar_cboxfield"
                      placeholder="Enter Value"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__fbar_cboxcol">
                <div className="cltdetails__fbar_cboxfieldbox">
                  <label className="cltdetails__fbar_cboxfieldlbl">
                    Name of Joint Owner (if not spouse)
                  </label>
                  <div className="cltdetails__fbar_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__fbar_cboxfield"
                      placeholder="Enter Description"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="cltdetails__fbar_checkboxitm2"
          style={{ border: "none" }}
        >
          <div className="cltdetails__fbar_cbicbox">
            {" "}
            <Checkbox
              defaultChecked
              sx={{
                "&.Mui-checked": {
                  color: "rgba(29, 66, 102, 1)",
                },
              }}
            />
          </div>
          <div className="cltdetails__fbar_cbirttxt">
            I declare that the information in this application is true and
            correct
          </div>
        </div>
        <div className="cltdetails__fbar_savebtnwrap">
          <button className="cltdetails__fbar_savebtn">Save</button>
        </div>
      </div>
      <div className="cltdetails__fbar_contentwrap">
        <div className="cltdetails__fbar_bottombtns">
          <button className="cltdetails__fbar_bbtnfilled">Submit</button>
          <button className="cltdetails__fbar_bbtnoutlined">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default FBAR;
